<template>
  <v-btn
      color="deep-purple"
      :style="{
        marginBottom: mainPadding.bottom,
        marginRight: mainPadding.right
      }"
      @click="onClick"
      dark
      bottom
      right
      fixed
      large
      rounded>
    <v-icon class="mr-2">mdi-arrow-u-down-left-bold</v-icon>
    通常モードに戻る
  </v-btn>
</template>

<script>
import PageStoreMixin, {mapPageStores} from "@/utils/PageStoreMixin";

export default {
  name: "GoNormalBtn",
  mixins: [PageStoreMixin],
  inject: ['mainPadding'],
  computed: {
    ...mapPageStores({
      useEasyHome: {alt: true, key: 'app.useEasyHome'},
    }),
  },
  methods: {
    onClick() {
      this.useEasyHome = false;
      this.$router.push('/');
    }
  }
}
</script>

<style scoped>

</style>
